import { useHref, useLocation } from 'react-router-dom';

interface ILocationState {
  from?: string;
}

/**
 * The page a sign-in from here should return the user to.
 *
 * PrivateRoute sends unauthenticated visitors to the home route and records the
 * page it denied them in `location.state.from`. Without that, a deep link is
 * already gone by the time a sign-in form renders — the URL says `/` — and the
 * user lands on the SPA root after signing in rather than where they were
 * headed.
 *
 * Prefixed with the router basename because the server is told a site-wide
 * path, not a router one, and hands it back for the client to navigate to.
 */
export const useSignInRedirectTarget = () => {
  const basename = useHref('/').replace(/\/$/, '');
  const location = useLocation();

  const from = (location.state as ILocationState)?.from;

  return `${basename}${from ?? `${location.pathname}${location.search}`}`;
};
